/**
 * Frontend counterpart to Nest's `FREE_MODE_ENABLED` server flag. When on:
 *   - billing-related API calls are skipped (no `/payments/plans` fetches,
 *     no expired-subscription probes)
 *   - the Mixpanel analytics pipeline is not initialized, so `/events`
 *     batches never fire
 *
 * Toggled via `VITE_FREE_MODE_ENABLED=true` in the frontend `.env`. Keep in
 * sync with the backend `FREE_MODE_ENABLED` so what the UI shows and what
 * the API enforces stay aligned.
 */
export const isFreeModeEnabled = (): boolean => {
  // Vite exposes env vars on `import.meta.env`
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // @ts-ignore
    if (String(import.meta.env.VITE_FREE_MODE_ENABLED) === 'true') return true;
  }
  if (typeof process !== 'undefined' && process.env) {
    if (String(process.env.VITE_FREE_MODE_ENABLED) === 'true') return true;
  }
  return false;
};
